import React from 'react'
import './Configs.scss'
import { Tabs } from 'antd'
import { connect } from 'react-redux'
import { switchConfig, removeConfig } from '@store/actions/index'

const mapDispatchToProps = dispatch => ({
  onChange: activeKey => {
    dispatch(switchConfig(activeKey))
  },
  onEdit: (targetKey, action) => {
    if (action === 'remove') {
      dispatch(removeConfig(targetKey))
    }
  },
})

const mapStateToProps = state => {
  const configs = {}
  state.panes.panes.forEach(pane => {
    if (state.tree[pane.id]) {
      configs[pane.id] = state.tree[pane.id].config
    }
  })
  return {
    panes: state.panes.panes,
    configs,
    activeKey: state.panes.activeKey,
  }
}

const ModulConfig = ({ onChange, onEdit, panes, configs, activeKey }) => {
  return (
    <div className="config-container">
      <Tabs
        className="tabBox"
        hideAdd
        onChange={onChange}
        activeKey={activeKey}
        type="editable-card"
        onEdit={onEdit}
      >
        {panes &&
          panes.map((panel: any) => (
            <Tabs.TabPane tab={panel.id} key={panel.key} closable={panel.closable}>
              <panel.content id={panel.id} pid={panel.pid} config={configs[panel.id]} />
            </Tabs.TabPane>
          ))}
      </Tabs>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ModulConfig)
